export default "__VITE_ASSET___jZgeklK__"